import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

export default merge(Item(), {
    state() {
        return {
            id: null,
            external_id: null,
            name: null,
            has_terms: null,
            category: null,
            category_id: null,
            users_count: null,
            updated_at: null,
            created_at: null,
            users: null,

            order: null,
        };
    },

    getters: {
        id: state => {
            return state.id;
        },
    },

    actions: {},

    mutations: {},
});
